export default __webpack_public_path__ + "static/media/impact-gif2.2004c313.gif";